import { Colors } from "@/constants/Colors";
import { FontFamilies } from "@/constants/Typography";
import React from "react";
import {
  StyleSheet,
  Text,
  TouchableOpacity,
  type TouchableOpacityProps,
} from "react-native";

export type ButtonProps = TouchableOpacityProps & {
  title: string;
  variant?: "primary" | "secondary";
  lightColor?: string;
  darkColor?: string;
};

export function Button({
  title,
  variant = "primary",
  style,
  lightColor,
  darkColor,
  ...rest
}: ButtonProps) {
  const backgroundColor =
    variant === "primary" ? Colors.primary : "transparent";
  const textColor = variant === "primary" ? "#FFFFFF" : "#000000";

  return (
    <TouchableOpacity
      style={[
        styles.button,
        {
          backgroundColor,
          borderColor: variant === "secondary" ? "#000000" : "transparent",
          borderWidth: variant === "secondary" ? 1 : 0,
        },
        style,
      ]}
      {...rest}
    >
      <Text style={[styles.text, { color: textColor }]}>{title}</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    height: 58,
    borderRadius: 100,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 24,
  },
  text: {
    fontSize: 17,
    fontFamily: FontFamilies.InterTight.SemiBold,
  },
});
